// PRODUCTION INCIDENT (all employees affected): this used to default to
// the hardcoded absolute production URL, overridable via
// REACT_APP_API_URL. That default was safe ONLY as long as no `.env.local`
// happened to exist on whatever machine ran `npm run build` -- but CRA's
// REAL env-file precedence for EVERY mode, including a production build,
// is `.env.production.local > .env.local > .env.production > .env`
// (`.env.local` is NOT dev-only -- a common misconception). A `.env.local`
// created for local dev convenience (pointing at a local backend) silently
// won during a production build run from that same checkout, baking
// http://localhost:5000/api into the deployed bundle and breaking login
// for every employee, with no `.env.production`/`.env` in the way to catch
// it.
//
// Fix: default to a SAME-ORIGIN relative "/api" instead of any absolute
// URL. This is not just a safer default -- it is the CORRECT one for how
// this app is actually deployed: the backend (index.js) serves the
// compiled frontend build AND every /api/* route from the SAME origin
// (see index.js's own static-serving + SPA-fallback + /api routers), so a
// relative base resolves correctly in production with zero configuration,
// and can never be poisoned by a stray env file again. Local development
// (`npm start`) needs no env var either -- see package.json's own
// "proxy": CRA's dev server forwards any unresolved (relative) request to
// the local backend automatically.
//
// REACT_APP_API_URL remains a supported, explicit override (e.g. to point
// this frontend at a genuinely different backend origin) -- just no longer
// the only thing standing between a stray env file and a broken production
// deploy.
export const API_URL = process.env.REACT_APP_API_URL || "/api";